import {css} from '@emotion/react'
import React from 'react'
import CloseIcon from '../../../images/x-button.svg'
import {getLinkData} from './qrCodeHelpers'

const translations = {
    en: {
        scanQr: 'Scan QR code with your phone',
    },
    fr: {
        scanQr: 'Scannez le code QR avec votre téléphone',
    },
    de: {
        scanQr: 'Scannen Sie den QR-Code mit Ihrem Telefon',
    },
    nl: {
        scanQr: 'Scan de QR-code met uw telefoon',
    },
}

const QrModal = ({languageCode = 'en', setShowModal}) => {
    const text = translations[languageCode] || translations.en
    const qrCodeData = getLinkData()
    const QrCodeComponent = qrCodeData.qrCode
    return (
        <div
            css={css`
                position: fixed;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: rgba(0, 0, 0, 0.6);
                z-index: 3;
                display: flex;
                justify-content: center;
                align-items: center;
            `}
        >
            <div
                css={css`
                    border-radius: 50px;
                    background: #fff;
                    position: relative;
                    min-width: 400px;
                    min-height: 400px;
                    padding: 32px 40px 40px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                `}
            >
                <CloseIcon
                    css={css`
                        position: absolute;
                        top: 28px;
                        right: 28px;
                        cursor: pointer;
                        width: 12px;
                        height: 12px;
                    `}
                    onClick={() => setShowModal(false)}
                />
                <p
                    css={css`
                        max-width: 225px;
                        color: #000;
                        text-align: center;
                        leading-trim: both;
                        text-edge: cap;
                        font-family: Inter;
                        font-size: 20px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: 24px; /* 120% */
                        margin-bottom: 32px;
                    `}
                >
                    {text.scanQr}
                </p>
                <QrCodeComponent
                    css={css`
                        width: 274px;
                        height: auto;
                    `}
                />
            </div>
        </div>
    )
}

export default QrModal
